import React from 'react';

import moment from 'moment';

import { positionFundRate } from './positionFundRate';

import TextButton from 'CommonComponents/TextButton';

import XMarkIcon from 'Assets/icons/xmark.svg';

/**
 * Whether a position fund request is still open.
 *
 * Compared against `status`, which the model's accessor rewrites to the
 * UNTRANSLATED 'PENDING' — never against `status_label`, which is the same
 * value passed through __() and would stop matching the moment the user's
 * locale is not English.
 */
export const isPositionFundApprovalPending = (row, pendingStatus) => row.status === pendingStatus;

/**
 * One position fund request a user raised.
 *
 * Rendered by Home's unified My Requests list. `typeLabel` and `showValue` are
 * optional and additive — see UserRequestListPurchaseRequisitionsRow.
 */
export default function UserRequestListPositionFundApprovalsRow({ row, typeLabel, showValue, rowClassName, isPending, onView, onCancel }) {
    return (
        <tr className={rowClassName}>
            <td className="tw-cursor-pointer inbud-date-cell" onClick={onView}>
                {moment(row.created_at).format('YY-MM-DD')}
            </td>
            {!!typeLabel && (
                <td className="tw-cursor-pointer" onClick={onView}>
                    {typeLabel}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.position.name} {row.position.last_name}
            </td>
            {!!showValue && (
                <td className="tw-cursor-pointer inbud-numeric-cell" onClick={onView}>
                    {positionFundRate(row.amount_data)}
                </td>
            )}
            <td className="tw-cursor-pointer" onClick={onView}>
                {row.canceled_at ? $t('Canceled') : row.status_label}
            </td>
            <td className="border-right-0">
                {isPending(row) && !row.canceled_at && (
                    <TextButton variant="danger" onClick={() => onCancel(row)}>
                        <XMarkIcon className="tw-w-3 tw-h-3" />
                        {$t('Cancel')}
                    </TextButton>
                )}
            </td>
        </tr>
    );
}
